import workspaceQuery from 'graphql/queries/supplier/PurchaseRefundWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/supplier/PurchaseRefundListQuery.graphql';
import instanceQuery from 'graphql/queries/supplier/PurchaseRefundQuery.graphql';
import defaultQuery from 'graphql/queries/supplier/PurchaseRefundDefault.graphql';
import mutationQuery from 'graphql/mutations/supplier/PurchaseRefundMutation.graphql';
import temporaryMutationQuery from 'graphql/mutations/supplier/SavePurchaseRefundTempMutation.graphql';
import aggregateQuery from 'graphql/queries/supplier/PurchaseRefundAggregateQuery.graphql';
import fragment from 'graphql/fragments/supplier/PurchaseRefundFragment.graphql';

import { formActions } from 'actions/supplier/PurchaseRefundAction';

const PurchaseRefund = {
  type: 'PurchaseRefund',
  title: 'Supplier Refunds',
  formTitle: 'Supplier Refund',
  formUrl: '/Suppliers/Refund/Details/',
  workspaceUrl: '/Suppliers/Refund/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentNumber',
  },
  aggregate: aggregateQuery,
  fragment,
  screenReference: 'SUPPLIER_REFUND',
  actions: formActions,
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED'],
    },
  ],
};

export default PurchaseRefund;
